module.exports = __webpack_public_path__ + "static/media/parts_05.ed3f008d.svg";